import React from 'react';
import { Box } from '@material-ui/core';

const NotAuthorizedMessage = ({ message }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      width: '100%',
    }}
  >
    {message}
  </Box>
);

export default NotAuthorizedMessage;
